"use strict";

exports.__esModule = true;
exports["default"] = Image;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Image(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M486.001 80H25.998C12.187 80 1 91.204 1 104.993v302.996C1 421.815 12.187 433 25.998 433h460.003C499.812 433 511 421.815 511 407.988V104.993C511 91.204 499.812 80 486.001 80zM354.077 354.556H101.643c-6.167 0-8.851-12.313-6.053-17.716l91.756-178.377c2.911-5.439 7.507-7.393 10.419-1.971l52.832 100.046 33.446-64.157c2.3-4.347 5.976-4.77 8.314-.364l66.547 147.064c2.337 4.346.115 15.475-4.827 15.475zm19.614-156.89c-21.377 0-38.694-17.313-38.694-38.705s17.317-38.744 38.694-38.744c21.339 0 38.731 17.352 38.731 38.744.001 21.392-17.392 38.705-38.731 38.705z"
  }));
}